module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.3f24eac4.svg";